import { createContext, useContext } from 'react';

/** Shared state for the User Administration screens; filled in by UserAdmin.js. */
export const UaContext = createContext(null);

export const useUa = () => useContext(UaContext);
